


















































import Vue, { PropOptions } from 'vue';
import API from '@/api/common';
import util from '@/components/util';
import NOC from '@/class/common/const';
import * as NOCArray from '@/personal/array';
import * as models from '@/class/models/views/contact';
import {IAPP} from '@/class/models/views/app';
import VariableInput, {IVariableInput, INPUT_TYPE} from '@/components/util/VariableInput.vue';
import * as validation from '@/personal/validation';

export default Vue.extend({
  name: 'Contact',
  props: {
    appData: Object as PropOptions<IAPP>,
  },
  components: {
    ...util, VariableInput,
  },
  data() {
    return {
      editFlag: true,
      disabled: false,
      formData: {
        category: 0,
        content: '',
      } as models.IContact,
      items: [
        {key: 'mail', name: 'メール', placeholder: '', required: true, checks: [validation.CHECK_TYPE.EMAIL], error: '', max: 40},
        {key: 'category', name: 'カテゴリー', type: INPUT_TYPE.SELECT, placeholder: '', required: false, checks: [], error: '', options: NOCArray.CONTACT },
        {key: 'content', name: 'お問い合わせ内容', type: INPUT_TYPE.TEXTAREA, placeholder: '500文字以内', required: true, checks: [], error: '', max: 500},
      ] as IVariableInput[] ,
    };
  },
  async mounted() {
    // データ取得
    // todo:tempkara
    this.$emit('pushPath', this.$route.path);
    this.formData.regist = true;
  },
  methods: {
    async onClickContact(): Promise<boolean> {

      // メールを合成
      this.formData.mail = this.appData.mail;

      // validation エラーの場合
      if (validation.checkValues(this.formData, this.items) > 0) {
        return false;
      }
      this.disabled = true;
      // api start
      const api = new API();
      const res = await api.post<models.IContact, {deneid: boolean}>('contact', this.formData);
      this.disabled = false;
      // result
      if (res.result) {
        if (!res.data.deneid) {
          this.editFlag = false;
          // console.log(this.editFlag);
        } else {
          this.$emit('info', '1日のお問い合わせは4件までになります。');
        }
      } else {
        this.$emit('info', '通信できませんでした。');
        return false;
      }
      return true;
    },
    onPushPath(path: string) {
      this.$router.push(path, () => {});
      this.$emit('pushPath', path);
    },
  },
});

